import { i18nFilter, translate } from "app/filters/i18nFilter";
import { percentageSignFilter } from "app/filters/ngFilters";
import ReactDOMServer from "react-dom/server";
import { ChangeTooltip } from "@similarweb/ui-components";
import styled from "styled-components";
import { getTooltipHeader } from "app/UtilitiesAndConstants/UtilitiesComponents/chartTooltipHeaderWithMTDSupport";

const TooltipWrapper = styled.div`
    > div {
        width: 300px;
    }
`;

export function changeTooltipFormatter(
    name: any,
    yFormatter: any,
    isWindow: any,
    duration: any,
    isPercents = false,
    granularity: any,
    lastSupportedDate: any,
    getChangeColor = undefined,
) {
    return function () {
        const { points } = this;
        // sort by x by chronological order
        points.forEach((p) => p.series.data.sort((a, b) => (a.x > b.x ? 1 : -1)));
        const changeTooltipProp = (points) => {
            return points.map((point) => {
                const sortedDataPoints = point.series.data.sort((p1, p2) => p1.x - p2.x);
                const pointIndex = sortedDataPoints.findIndex((p) => p.x === point.x);
                const previousPointData = sortedDataPoints[pointIndex ? pointIndex - 1 : 0];
                const isNew = previousPointData.y === 0 && point.y !== 0;
                const changeString = isNew && i18nFilter()("common.tooltip.change.new");
                const changeValue = previousPointData.y ? point.y / previousPointData.y - 1 : 0;
                const changeDisplayValue =
                    changeString || !changeValue ? changeString : percentageSignFilter()(changeValue, 2);
                return {
                    value: yFormatter({ value: point.y }),
                    color: point.series.color,
                    displayName: point.series.name,
                    change: changeDisplayValue,
                };
            });
        };

        const changeTooltipProps = {
            header: getTooltipHeader(granularity, points, lastSupportedDate),
            ...(getChangeColor && { getChangeColor }),
            tableHeaders: [
                { position: 0 },
                { position: 1, displayName: name },
                { position: 2, displayName: translate("website.analysis.search.overview.graph.traffic.point.change.tooltip") },
            ],
            tableRows: changeTooltipProp(points),
            showChangeColumn: true,
        };
        return ReactDOMServer.renderToString(
            <TooltipWrapper>
                <ChangeTooltip {...changeTooltipProps} />
            </TooltipWrapper>,
        );
    };
}
